/**
 * Check browser support for localStorage and sessionStorage
 * @returns {boolean}
 */
export const browserSupportStorage = () => {
    return typeof Storage !== 'undefined';
};
